import { LucideIcon, Search, FileText, Users, MessageSquare, Inbox, Bell, Hash } from 'lucide-react'

const ICON_MAP: Record<string, LucideIcon> = {
  search: Search,
  file: FileText,
  users: Users,
  message: MessageSquare,
  inbox: Inbox,
  bell: Bell,
  hash: Hash,
}

interface EmptyStateProps {
  icon?: LucideIcon | string
  title?: string
  description?: string
  action?: React.ReactNode
  className?: string
}

export default function EmptyState({
  icon,
  title,
  description,
  action,
  className = '',
}: EmptyStateProps) {
  const Icon = typeof icon === 'string' ? ICON_MAP[icon] || Search : icon
  return (
    <div className={`text-center py-16 ${className}`}>
      {Icon && (
        <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-secondary flex items-center justify-center text-muted-foreground">
          <Icon className="w-6 h-6" />
        </div>
      )}
      {title && <h3 className="font-medium text-foreground mb-2">{title}</h3>}
      {description && <p className="text-muted-foreground text-sm max-w-xs mx-auto">{description}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  )
}
